import React, { ReactElement } from 'react';
import FrameTopBannerView from './FrameTopBannerView';
import { ThemeTopBannerType } from '@/modules/types/theme';

import { useSelector } from 'react-redux';
import { ElearningPlayerStateType } from '@/components/Player/modules/reducers/elearningPlayer';

const FrameTopBanner = ({
  isMobileView,
}: {
  isMobileView?: boolean;
}): ReactElement => {
  const {
    content: { elearning },
  } = useSelector(
    (state: { elearningPlayer: ElearningPlayerStateType }) =>
      state.elearningPlayer,
  );

  if (!elearning) {
    return <div />;
  }

  const result: ThemeTopBannerType = {
    title: '',
    metadata: {},
    isMobileView,
  };
  const titleMetadata = elearning?.titleMetadata as any;
  result.title = elearning?.name as any;
  if (titleMetadata)
    result.metadata = {
      elearningName: {
        minWidth: '450px',
        fontFamily: `${titleMetadata.nameFont}`,
        fontSize: `${titleMetadata.nameSize}`,
        color: `#${titleMetadata.nameColor}`,
        left: isMobileView ? '0' : `${titleMetadata.posX}px`,
        top: isMobileView ? '30px' : `${titleMetadata.posY}px`,
        backgroundColor: isMobileView ? '#7e9fb6' : '',
        padding: isMobileView ? '.5rem' : '',
        height: isMobileView ? '35px' : '',
        textAlign: isMobileView ? 'left' : '',
      },
    };

  return <FrameTopBannerView {...result} />;
};

export default FrameTopBanner;
